import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import {Box, Heading, Text} from '@tenancy.nz/ui';
import {motion} from 'motion/react';

function EnquirySuccess({address = undefined}) {
  return (
    <motion.div>
      <Box sx={{display: 'flex', justifyContent: 'center'}}>
        <Box
          sx={{
            bgcolor: 'common.white',
            maxWidth: 360,
            width: '100%',
            p: 8,
            borderRadius: '10px',
            boxShadow: '0 0 12.457px rgba(0, 0, 0, 0.1)',
          }}>
          <Stack gap={4} alignItems="center" pt={3} pb={3}>
            <Heading as="h3" align="center">
              Thank you for your enquiry
            </Heading>
            <Text align="center" sx={{fontSize: 14}}>
              Your request will be reviewed, and you&#39;ll be contacted if
              further action is needed.
            </Text>
            {address && (
              <Text align="center" sx={{fontSize: 14}}>
                Property address:
                <br />
                <strong>{address}</strong>
              </Text>
            )}
          </Stack>
        </Box>
      </Box>
    </motion.div>
  );
}

EnquirySuccess.propTypes = {
  address: PropTypes.string,
};

export default EnquirySuccess;
